import { useNavigate } from "react-router-dom";
import React from "react";
import styles from "./LoginCallbackPage.module.css";

//  This is the page we get redirected to after we authenticate in AWS.
export function LoginCallbackPage() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const storedLocation = localStorage.getItem("redirect");

    if (storedLocation && storedLocation !== "/") {
      navigate(decodeURIComponent(storedLocation));
    } else {
      navigate("/vendor", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Todo: styles? really? in this economy?
  return <div className={styles.centered}>Please wait...</div>;
}
